import styles from './result-table-styles.module.css';
import React from 'react';
import { useDiagramStore } from '../../store/useDiagramStore';

interface ResultTableProps {
    children: React.ReactNode;
    isMain?: boolean;
}

const ResultTable = ({ children, isMain = true }: ResultTableProps) => {
    const [graphType] = useDiagramStore((state) => [state.graphType]);

    return (
        <div className={`${styles.table} ${graphType ? styles[graphType] : ''} ${isMain ? styles.main : ''}`}>
            {children}
        </div>
    );
};

export default ResultTable;
